<template>
  <div class="push" :class="{ '--shown': isShown, '--hidden': isHidden, ['--' + push.name]: true }" @click="close">
    <div class="push__left">
      <div class="push__img">
        <img :src="icon" alt="" />
      </div>
    </div>
    <div class="push__content">
      <div class="push__from">{{ push.from }}</div>
      <div class="push__text">{{ push.text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Push',
  props: {
    push: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isShown: false,
      isHidden: false,
    }
  },
  computed: {
    icon() {
      return require('../assets/push/' + this.push.name + '.svg')
    },
  },
  methods: {
    close() {
      this.isHidden = true
      setTimeout(() => {
        this.$emit('close')
      }, 300)
    },
  },
  mounted() {
    setTimeout(() => {
      this.isShown = true
    }, 20)
  },
}
</script>

<style lang="scss">
.push {
  position: relative;
  border-radius: 3px;
  padding: 20px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  margin: 10px;
  cursor: pointer;
  opacity: 0;
  transform: translateY(-50%);
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  /*max-height: 150px;*/
  will-change: max-height;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  background: url(../assets/close.svg) no-repeat right 20px top 20px #fff;

  &.--miss {
    background-color: #731982;
    color: #fff;
  }

  &.--shown {
    opacity: 1;
    transform: translateY(0);
  }

  &.--hidden {
    opacity: 0;
    /*max-height: 0;*/
  }

  &__left {
    margin-right: 10px;
    width: 60px;
  }

  &__from {
    font-size: 15px;
    line-height: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    padding-right: 15px;
  }

  &__text {
    font-size: 15px;
    line-height: 20px;
  }
}
</style>
